import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"
import EnvVars from "~/env-vars"

import { getSolarProposalErrorStatus, retrySolarRead } from "./solar-read-retry"
import type { SolarProposalDto } from "../dto/solar-proposal.dto"
import { solarProposalService } from "../services/solar-proposal.service"

export { getSolarProposalErrorStatus }

/**
 * The Solar Proposal header and hero read. 403 and 404 are answers, not
 * transient failures, so they are not retried and the shell renders them; a
 * 401 sends the seller through SSO and back, as the Battery read does.
 */
export default function useSolarProposal(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.byId(proposalId ?? ``),
    queryFn: () => solarProposalService.getById(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarRead,
    onError: (error) => {
      if (getSolarProposalErrorStatus(error) !== 401) {
        return
      }

      localStorage.setItem(`jwt`, ``)
      const { pathname, search, hash } = window.location
      sessionStorage.setItem(
        `redirectUrl`,
        JSON.stringify(`${pathname}${search}${hash}`),
      )
      window.location.replace(`${EnvVars.API_URL}/auth/sso/login`)
    },
  })
}
